export default __webpack_public_path__ + "static/media/yacht2.f519dfdd.webp";